/**
 *
 * MaterialCourseCpnt
 *
 */

import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
//import Swal from 'sweetalert2';

import { ClassRestrictionMixin } from '@/mixins/ClassRestriction';

export default {
  name: 'MaterialFile',

  mixins: [ClassRestrictionMixin],

  props: {
    p_file: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapGetters({
      Course: 'MainModeCourse/Course',
    }),

    ///
    c_courseId() {
      return Number(this.$route.params.courseId);
    },

    ///
    c_restrictStudent() {
      return this.Course.restrictStudent;
    },

    c_file() {
      let fileType = this.p_file.fileType;
      if ('doc' === fileType || 'docx' === fileType) {
        fileType = 'word';
      }
      return {
        ...this.p_file,
        c_fileType: fileType,
      };
    },
  },

  methods: {
    ...mapActions('MainModeCourse', {
      ma_getClassRestrictionWebTreePath: 'getClassRestrictionWebTreePath',
    }),

    async downloadMaterial() {
      if (!this.p_file.filePath) {
        await this.ma_getClassRestrictionWebTreePath(this.p_file);
      }
      const filePath = this.p_file.filePath.replace('http://', 'https://');
      window.open(filePath, '_blank');
    },

    ///
    setPromiseGetClassRestriction() {
      this.promiseClassRestrictionCoursePageInfo = window.promiseGetCourse;
    },
  },
};
